import React from 'react';
import { Button, Modal, Paragraph } from 'elmo-elements';
import { TPostBookingPayload } from 'src/types';
import { useOnCreateConfirmationModalState } from './hooks';

export const OnCreateConfirmationModal = (
    props: TPostBookingPayload & { message: string; onClose: () => void }
) => {
    const { onClose, message } = props;
    const { isAdding, handleClickPrimaryButton } = useOnCreateConfirmationModalState(props);
    return (
        <Modal
            id="confirmation-modal"
            title="Confirmation of booking"
            type="medium"
            isOpened
            closeModal={onClose}
            primaryButton={
                <Button
                    id="save-booking"
                    ariaLabel="save-booking"
                    type="primary"
                    isLoading={isAdding}
                    isDisabled={isAdding}
                    onClick={handleClickPrimaryButton}
                >
                    Save
                </Button>
            }
        >
            <Paragraph>{message}</Paragraph>
        </Modal>
    );
};
